import React, { createContext, useContext } from 'react';

const ListagemConfiguracaoContext = createContext(null);

export const ListagemConfiguracaoContextProvider = ListagemConfiguracaoContext.Provider;

export const useListagemConfiguracaoContextOptional = () => useContext(ListagemConfiguracaoContext);
